import type { ReactElement } from 'react';
import React from 'react';
import { FLOOR_AREA_RANGES } from '../constants/filtersOptions';
import SliderInput from './SliderInput';
import { FilterWrapper } from './FilterWrapper';

type FloorAreaFilterProps = {
  searchQueryFloorAreaRange: Array<number>;
  onChange: (newPriceRange: number[]) => void;
  showDivider?: boolean;
  hideHeading?: boolean;
};

export const FloorAreaFilter = ({
  searchQueryFloorAreaRange,
  onChange,
  showDivider,
  hideHeading,
}: FloorAreaFilterProps): ReactElement => (
  <FilterWrapper title="Floor area" showDivider={showDivider} hideHeading={hideHeading}>
    <SliderInput
      filterRanges={FLOOR_AREA_RANGES}
      textInputLabel="(m²)"
      searchQueryRange={searchQueryFloorAreaRange}
      onChange={onChange}
    />
  </FilterWrapper>
);
